
<div class="page-padding">
  <div class="panel">
    <div class="panel__header" >
      <span class="panel__header__title">{{'Pre and Post Hire Report' | translate | async}} </span>
    </div>
    <mat-horizontal-stepper [linear]="true" [selectedIndex]="currentStep"  #stepper>
      
      <mat-step>
        <ng-template matStepLabel>{{'Select Equipment' | translate | async}}</ng-template>
        <div class="step-container"> 
          <div class="margin-b--16">
            <b>{{'Select Equipment for Hire Report' | translate | async}}</b>
          </div>
          <div class="margin-bottom-24">
            <mat-form-field  >
              <mat-select [(ngModel)]="selectedCustomer" name="customer" placeholder="{{'Select Customer' | translate | async}}" >
                <mat-option *ngFor="let option of CustomerList" [value]="option.customerId"   (click)="onChangeCustomer()" id="customerId">
                  {{option.customerName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="margin-bottom-24">
            <mat-form-field>
              <mat-label>{{'Select Jobsite' | translate | async}}</mat-label>
               <mat-select (selectionChange)="jobsiteChanged($event)" [(ngModel)]="selectedSiteId">
                <mat-option *ngFor="let option of jobsitebyCustomerID" [value]="option.crsf_auto" >
                  {{option.site_name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="margin-bottom-24">
            <mat-form-field>
              <mat-label>{{'Select Equipment' | translate | async}}</mat-label>
               <mat-select (selectionChange)="equipmentChanged($event)" [(ngModel)]="selectedEQId">
                <mat-option *ngFor="let contain of equipmnentList" [value]="contain.EquipmentId" (click)="loadEquipmentDetails(); loadEquipmentInspectionsDetails(); loadEquipmentSystemsDetails(); goToStep(1)">
                  {{contain.UnitNo}}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <!-- <div>
            <button mat-raised-button color="warn" (click)="goToStep(1); loadEquipmentDetails(); loadEquipmentInspectionsDetails(); loadEquipmentSystemsDetails()"  >Next</button>
          </div> -->
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{'Add Inspection and Comments' | translate | async}}</ng-template>
          <div class="step-container">
            <div class="margin-bottom-24">
            
              <div class="panel" *ngIf="equipmentDetails != null">
                <div class="panel__header">
                  <span class="panel__header__title">
                    {{'Equipment Details' | translate | async}}
                  </span>
                  <div class="panel__header__button-container">
                   


                            <button style="background-color: #DC5C16;" mat-raised-button (click)="generateUndercarriageReport()"[disabled]="isLoading !=true && isLoadingGetTable !=true"> <mat-icon>file_download</mat-icon>{{'Download Report' | translate | async}}</button>
                            <!-- <button mat-raised-button (click)="openSendEmailDialog()" [disabled]="isReportGenerated !=true" >Send Report</button> -->

                       
                           

                              <button
                              mat-icon-button
                              [disabled]="isReportGenerated !=true"
                              aria-label="Example icon-button with a heart icon"
                              (click)="openSendEmailDialog()">
                              <mat-icon>send</mat-icon> <span class="button__text">Send Report</span>
                            </button>
                  </div>
                </div>
                <div class="panel__content flex flex--align-center">
                  <div class="overall-eval-container">
                    <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo"
                       />
                    <div class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.Eval }}" style="margin-right: 1px;">
                      {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
                    </div>
                  </div>
                  <div class="column-container flex-grow" style="margin-left: 1%;">
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Customer' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.CustomerName}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Job Site' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.JobsiteName}}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Serial Number' | translate | async}}
                        </span>
                        <span class="text-block__important" style="color: #EB5757; font-weight: 800;">
                          {{equipmentDetails.SerialNumber}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Unit Number' | translate | async}}
                        </span>
                        <span class="text-block__important" style="color: #EB5757; font-weight: 800;">
                          {{equipmentDetails.UnitNumber}}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column" *ngIf="equipmentDetails.AdditionalUnitNo!= null ">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Additional Unit Number' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.AdditionalUnitNo}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
          
                        </span>
                        <span class="text-block__important">
          
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Last Inspection Date' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.LastInspectionDate}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Next Inspection Date' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{ equipmentDetails.NextInspectionDate }}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Meter Reading' | translate | async}} (SMU/{{'HourMeter' | translate | async}})
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.Smu}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                         {{'Life to Date' | translate | async}} (LTD)
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.Ltd}}
                        </span>
                      </div>
                    </div>
          
                    <div class="column-container__column"
                      *ngIf="(equipmentDetails.FamilyId==177 || equipmentDetails.FamilyId==203)">
                      <div class="text-block">
                        <span class="text-block__label">
                         {{'Propel Hrs' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.propelHrs!=null? equipmentDetails.propelHrs:'-'}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Propel %' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.propelPercentage!=null?equipmentDetails.propelPercentage.toFixed(1):'-'}}
                        </span>
                      </div>
                    </div>
          
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Make' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.Make}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Model' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.Model}}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          {{'Family' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.Family}}
                        </span>
                      </div>
                      <div class="text-block">
                        <span class="text-block__label">
                         {{'Setup Date' | translate | async}}
                        </span>
                        <span class="text-block__important">
                          {{equipmentDetails.EquipmentSetupDate}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>

            <div class="margin-bottom-24" style="width: 360px;">
              <!-- <mat-form-field>
                <mat-label>Inspection Type</mat-label>
                 <mat-select (selectionChange)="inspecChange($event)"  [(ngModel)]="inspectionType" >  
                  <mat-option [value]="1"  >Undercarriage</mat-option>
                  <mat-option [value]="2">Get Implement</mat-option>
                  <mat-option [value]="3">Digital Forms</mat-option>
                </mat-select>
              </mat-form-field> -->

              <mat-form-field>
                <mat-label>{{'Inspection Types' | translate | async}}</mat-label>
                 <mat-select (selectionChange)="inspecChange($event)"  [(ngModel)]="inspectionType_" multiple>  
                  <mat-option [value]="1"  (click)="showInspectiontypes(1)">{{'Undercarriage' | translate | async }}</mat-option>
                  <mat-option [value]="2" (click)="showInspectiontypes(2)">{{'Get Implement' | translate | async}}</mat-option>
                  <mat-option [value]="3" (click)="showInspectiontypes(3)">{{'Digital Forms' | translate | async}}</mat-option>
                </mat-select>
              </mat-form-field>
                <!-- <span class="material-icons" style="vertical-align: middle; cursor: pointer;" (click)="AddNewItem()">edit_note</span> -->
                    <!-- <button mat-raised-button (click)="generateUndercarriageReport()"[disabled]="isLoading !=true && isLoadingGetTable !=true">Download Report</button>
                    <button mat-raised-button (click)="openSendEmailDialog()" [disabled]="isReportGenerated !=true" >Send Report</button> -->
                    <!-- <button mat-raised-button (click) ="openReportContactDialog()" >Report Contacts</button>      -->
               
            </div>
  <!--undercarriage tab  -->
    
        <div *ngIf="isShowUndercarriageTab==true" >
            <div class="panel__content flex flex--align-center">
              <div class="overall-eval-container">
                 <div class="margin-bottom-24">
                <mat-label>{{'Undercarriage' | translate | async}}</mat-label>
                <!-- <span class="material-icons" style="vertical-align: middle;" (click) ="showUndercarriageTable()">fact_check </span> -->
               </div>
              </div>
              <div class="column-container flex-grow" style="margin-left: 1%;">
                <div class="column-container__column">
                  <div class="text-block">
                    <span class="text-block__label">
                      {{'Left Chain' | translate | async}}
                    </span>
                    <span class="text-block__important" style="color: #EB5757; font-weight: 800;">
                      {{labelLeftchain}}
                      


                    </span>
                  </div>                
                </div>
                <div class="column-container__column">
                  <div class="text-block">
                    <span class="text-block__label">
                      {{'Left Frame' | translate | async}}
                    </span>
                    <span class="text-block__important" style="color: #EB5757; font-weight: 800;">
                      <!-- {{equipmentDetails.leftchani}} -->
                      {{labelLeftFrame}}     
                    </span>
                  </div>                
                </div>
                <div class="column-container__column">
                  <div class="text-block">
                    <span class="text-block__label">
                      {{'Right Chain' | translate | async}}
                    </span>
                    <span class="text-block__important" style="color: #EB5757; font-weight: 800;">
                      <!-- {{equipmentDetails.leftchani}} -->
                      {{labelRightChain}}  
                    </span>
                  </div>                
                </div>
                <div class="column-container__column">
                  <div class="text-block">
                    <span class="text-block__label">
                      {{'Right Frame' | translate | async}}
                    </span>
                    <span class="text-block__important" style="color: #EB5757; font-weight: 800;">
                      <!-- {{equipmentDetails.leftchani}} -->
                      {{labelRightFrame}}
                    </span>
                  </div>                
                </div>               
             </div>   
        
            </div>
                                                 
            <div class="column-container__column">
              <div class="text-block">
             <mat-form-field appearance="DBSS" style="width: 400px; margin-left: 10%;">
               <mat-label>{{'On-Hire Inspection' | translate | async}}</mat-label>
                  <mat-select (selectionChange)="OnHireInsectionChanged($event)"  [(ngModel)]="OnHireInspectionUndercarriage">
                    <mat-option *ngFor="let insp of inspections" [value]="insp.InspDate" (click)="getInspectionreportingDetail(insp)" >
                      {{insp.Date}} - {{insp.Smu }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="DBSS" style="width: 400px;">
                  <mat-label>{{'Off-Hire Inspection' | translate | async}}</mat-label>
                  <mat-select (selectionChange)="OFFHireInsectionChanged($event)" >
                    <mat-option *ngFor="let insp of inspectionsFiltered_"[value]="insp.InspDate" (click)="getInspectionreportingDetailOff(insp)">
                      {{insp.Date}} - {{insp.Smu}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!--TT-5304 Point-->
                <!-- <span class="material-icons" style="vertical-align: middle; cursor: pointer;" (click) ="showUndercarriageTable()">fact_check </span> -->
                 </div>     
              
            </div>   

            <div class="column-container__column">
              <div class="text-block"  style="margin-left: 10%;">
               
                <!-- <button mat-raised-button (click)="generateUndercarriageReport()">Preview Report</button>
                <button mat-raised-button >Send Report</button>
                <button mat-raised-button (click) ="openReportContactDialog()" >Report Contacts</button>  -->
                <!-- <mat-form-field class="DBSS" style="margin-left: 1%;">
                  <input matInput placeholder="Report Name" [(ngModel)]="undercarriageReportName" name="undercarriageReportName">   
                </mat-form-field>    -->
            </div>
            </div>

              <div *ngIf=" isLoading ==true" >
              <mat-card style="margin-top: 10px;">  
     
               <!-- Table conect -->
                <div style="display: flex;flex-direction: row;">
                  <div style="width:40%">
                    <table class="table table--striped table--full-width">
                      <thead>
                        <tr style="height: 62px !important;">
                          <!-- <td><mat-checkbox ></mat-checkbox></td> -->
                          <th>{{'Name' | translate | async}}</th>
                          </tr>
                      </thead>             
                      
                            <ng-container *ngFor=" let c of SystemModelfiltered  ; let i =  index">
                        <tr>
                          <!-- <td style="padding: 13px 24px;"> <mat-checkbox  [checked]="Checkbox_Undercarriage" ></mat-checkbox></td> -->
                          <td style="padding: 13px 24px;"> <mat-checkbox  [checked]="Checkbox_Undercarriage" (change)='checkboxChangedUndercarriage($event,i);'></mat-checkbox></td>
                          <td class="tdClass" style="padding: 19px 24px;" title="{{c.Name}}">
                            <span>
                              <div class="SerialAndUnitText"> {{c.Name}}</div>
                            </span> </td>
                        </tr>
                      </ng-container>
                     
                    </table>
                  </div>


                  <div  style="overflow-x: auto; ">
                    <table class="table table--striped table--full-width">
                      <thead>
                        <tr>                         
                          <th> 
                            <div style="display: flex; flex-direction: column;width: 120px;">
                              <span>{{'Left' | translate | async}}</span> 
                              <span>{{inputUndercarriageOnHitreDate| date:'dd-MMM-yyyy'}}</span>
                            </div>
                          
                            </th>  
                         
                        </tr>
                      </thead>             
                      <ng-container *ngFor=" let on of SystemModelfiltered">   
                           
                        <tr >                    
                          <td class="tdClass" style="padding: 9px 17px;">          
                          
                            <span  class="Eval-U" style="margin-right: 50px; padding: 2px 5px;">
                              <div> {{on.WornPercentage.toFixed(1)}}%</div>{{on.Measurement.toFixed(1)}} mm 
                          </span> 
                          </td>                       
                        </tr>                         
                      </ng-container>
                    
                    </table>
                  </div>

                  <div  style="overflow-x: auto; ">
                    <table class="table table--striped table--full-width">
                      <thead>
                        <tr>                         
                         
                          <th>
                            <div style="display: flex; flex-direction: column;width: 120px;">
                              <span>{{'Right' | translate | async}}</span> 
                              <span>{{inputUndercarriageOnHitreDate| date:'dd-MMM-yyyy'}}</span>
                            </div>
                            
                             </th>  
                            
                        </tr>
                      </thead>             
                      <ng-container *ngFor=" let t of SystemModelfiltered_">                      
                        <tr >           
                          <!-- <td class="tdClass" style="padding: 19px 17px;">
                            <div ><span >{{t.WornPercentage.toFixed(1)}}%  / {{t.Measurement.toFixed(1)}} mm  </span> </div>
                          </td>  -->
                          
                          <td class="tdClass" style="padding: 9px 17px;">          
                          
                            <span  class="Eval-U" style="margin-right: 50px; padding: 2px 5px;">
                              <div> {{t.WornPercentage.toFixed(1)}}%</div>{{t.Measurement.toFixed(1)}} mm  
                          </span> 
                          </td>
                        </tr>                         
                      </ng-container>
                    </table>
                  </div>

                  <div  style="overflow-x: auto; ">
                    <table class="table table--striped table--full-width">
                      <thead>
                        <tr>                         
                          <th>
                            <div style="display: flex; flex-direction: column;width: 120px;">
                              <span>{{'Left' | translate | async}}</span> 
                              <span>{{inputUndercarriageOFFHitreDate| date:'dd-MMM-yyyy'}}</span>
                            </div>
                            <!-- Left {{inputUndercarriageOFFHitreDate| date:'dd-MMM-yyyy'}} -->
                          </th>  


                          </tr>
                      </thead>             
                      <ng-container *ngFor=" let t of SystemModelfilteredOff">                      
                        <tr >           
                          <!-- <td class="tdClass" style="padding: 19px 17px;">
                            <div>   <span >{{t.WornPercentage.toFixed(1)}}%  / {{t.Measurement.toFixed(1)}} mm    </span> </div> 
                          </td> 
                           -->
                          <td class="tdClass" style="padding: 9px 17px;">          
                          
                            <span  class="Eval-U" style="margin-right: 50px; padding: 2px 5px;">
                              <div>{{t.WornPercentage.toFixed(1)}}% </div>{{t.Measurement.toFixed(1)}} mm 
                          </span> 
                          </td>
                        </tr>                         
                      </ng-container>
                    </table>
                  </div>

                  <div  style="overflow-x: auto; ">
                    <table class="table table--striped table--full-width">
                      <thead>
                        <tr>                         
                          <th>
                            <div style="display: flex; flex-direction: column;width: 120px;">
                              <span>{{'Right' | translate | async}}</span> 
                              <span>{{inputUndercarriageOFFHitreDate| date:'dd-MMM-yyyy'}}</span>
                            </div>
                             </th>  
                         
                          </tr>
                      </thead>             
                      <ng-container *ngFor=" let t of SystemModelfilteredOff_">                      
                        <tr >           
                          <!-- <td class="tdClass" style="padding: 19px 17px;">
                            <div>   <span >{{t.WornPercentage.toFixed(1)}}%  / {{t.Measurement.toFixed(1)}} mm   </span> </div>
                          </td>  -->

                          <td class="tdClass" style="padding: 9px 17px;">          
                          
                            <span  class="Eval-U" style="margin-right: 50px; padding: 2px 5px;">
                              <div>{{t.WornPercentage.toFixed(1)}}%</div>{{t.Measurement.toFixed(1)}} mm 
                          </span> 
                          </td>
                                               
                        </tr>                         
                      </ng-container>
                    </table>
                  </div>

                  <div  style="overflow-x: auto; ">
                    <table class="table table--striped table--full-width">
                      <thead>
                        <tr>                         
                          <th>{{'Left % used' | translate | async}}</th>  
                          <th>{{'Right % used' | translate | async}}</th>  
                          <th>{{'Original Costs' | translate | async}}</th> 
                          <th>{{'Left' | translate | async}}</th> 
                          <th>{{'Right' | translate | async}}</th>  
                          <th></th>
                          </tr>
                      </thead>             
                      <ng-container *ngFor=" let row of worndifference;  let i = index">                      
                        <tr >           
                          <td class="tdClass" style="padding: 19px 17px;">
                            <div>
                              <span>{{row[0].Worn.toFixed(1)}}% </span> 
                              <!-- <span>{{row[0].Worn.toFixed(1)}}% / {{row[0].Measure.toFixed(1)}} mm</span>  -->
                            </div>
                          </td> 
                         
                          <td class="tdClass" style="padding: 19px 17px;">
                            <div>
                              <span>{{row[1].Worn.toFixed(1)}}% </span> 
                              <!-- <span>{{row[1].Worn.toFixed(1)}}% / {{row[1].Measure.toFixed(1)}} mm </span>  -->

                            </div>
                          </td>  

                          <td class="tdClass" >
                            <div><input type="number" style="border-width: 1px; width: 60%;" ng-model="inputcost" (input)="calLeft(row[0], $event,row,i);calRight(row[1], $event,row,i); TotalCost(i);" > </div>
                          </td>
                          <td>${{row[0].Calc>0 ?(row[0].Calc).toFixed(2): 0}}</td>
                          <td>${{row[1].Calc>0 ?(row[1].Calc).toFixed(2):0}}</td>                         
                        </tr>  
                         
                                           
                      </ng-container>
                      <td class="tdClass" style="padding: 19px 17px;"></td>
                      <td class="tdClass" style="padding: 19px 17px;"></td>
                      
                      <td class="tdClass" style="padding: 19px 25px;">{{'Total' | translate | async}}</td>   
                      <td class="tdClass" style="padding: 19px 17px;">${{totalLeftcost_.toFixed(2)}}</td> 
                      <td class="tdClass" style="padding: 19px 17px;">${{totalRightcost_.toFixed(2)}}</td> 
                    </table>
                  </div>
                </div>
           
                <!--end tables  -->
                <div class="column-container__column" style="margin-top: 1%">
                  <div style="flex: 1">
                    <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Leave a Comment' | translate | async}}</h4>         
                      <mat-form-field style="width: 1000px; " >                 
                        <textarea class="sc-textarea" matInput [(ngModel)]="UndercarriageReportComment" [ngModelOptions]="{standalone: true}"></textarea>
                      </mat-form-field>                       
                      <mat-form-field  appearance="fill" style="width: 400px;">
                        <mat-label>{{'Total Cost' | translate | async}}</mat-label>
                        <input matInput value="cost" [(ngModel)]="TotalCost_Undercarriage" >  
                        <mat-icon style="font-size: 15px;" matPrefix>$</mat-icon>                  
                        <!-- <span>{{TotalCostLeft + TotalCostRight }}</span> -->
                    </mat-form-field>                                                       
                      <mat-icon [ngStyle]="{ color: isUCfileUploades ? 'blue' : 'black' }" (click)="AddAttachmentDialogComponent()" style="cursor:pointer;">attach_file</mat-icon>                                                                                                   
                      <i (click)="inputValueImage.click()" class="material-icons button__icon"
                        style="color:black;cursor: pointer;margin-right: 20px;">{{isUCimageUploads ? "insert_photo":"wallpaper"}}
                        <input  #inputValueImage type="file" accept="image/*" style="display:none" (change)="onImageChanged($event);">
                      </i>                                       
                  </div>

                  <div class="text-block">                   
                  </div>                
                </div>   
                
                 <div *ngIf="isLoading ==false" style="display: flex;flex-direction: column;align-items: center;
                  justify-content: center;min-height: 500px;align-self: center;">
                        <mat-spinner></mat-spinner>
                  </div>
            </mat-card>
          </div>
        </div>
    
      
  <!--end undercarriage tab  -->

  <!-- Get Implement tab] -->

  <div *ngIf="isShowgetImplementTab==true">
    <div class="panel__content flex flex--align-center">
      <div class="overall-eval-container">
         <div class="margin-bottom-24">
           <mat-label>{{'Get Implement' | translate | async}}</mat-label>
        <!-- <span class="material-icons" style="vertical-align: middle;" (click) ="showGetImplementationTable()">fact_check </span> -->
       </div>
      </div>
      <div class="column-container flex-grow" style="margin-left: 1%;">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{'Implement Type' | translate | async}}
            </span> 
          

            <mat-form-field appearance="DBSS" style="width: 400px;" class="invisible">
              <mat-label>{{'Implement Type' | translate | async}}</mat-label>
              <mat-select >
                <mat-option *ngFor="let itype of ImplementList"  [value]="itype.ImplementID" >
                  {{itype.ImplementName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

          <mat-form-field appearance="DBSS" style="width: 400px;">
            <mat-label>{{'Implement Serial' | translate | async}}</mat-label>
            <mat-select (selectionChange) ="GetAllImplementDetails($event)" >
              <mat-option *ngFor="let iserial of ImplementSerialList"  [value]="iserial.get_auto" >
                {{iserial.Implementserial}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>              
     </div>
  </div>
                                         
  <div class="column-container__column">
    <div class="text-block">
      <mat-form-field appearance="DBSS" style="width: 400px; margin-left: 10%;">
        <mat-label>{{'On-Hire Inspection' | translate | async}}</mat-label>
        <mat-select  (selectionChange)="GETOnHireInsectionChanged($event)"  >
          <mat-option *ngFor="let insp of GetInspectionList" [value]="insp.InspectionDate"  (click)="getGETImplementDetailForTableON(insp)" >
            {{insp.InspectionDate| date:'dd-MMM-yyyy'}} - {{insp.MeterReding }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="DBSS" style="width: 400px;">
        <mat-label>{{'Off-Hire Inspection' | translate | async}}</mat-label>
        <mat-select (selectionChange)="GETOFFHireInsectionChanged($event)"   >
          <mat-option *ngFor="let insp of GetInspectionList_"[value]="insp.InspectionDate" (click)="getGETImplementDetailForTableOFF(insp)">
            {{insp.InspectionDate| date:'dd-MMM-yyyy'}} - {{insp.MeterReding }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <span class="material-icons" style="vertical-align: middle; cursor: pointer;" (click) ="showGetImplementationTable()">fact_check </span> -->
  
    </div>          
  </div>

  <div class="column-container__column">
    <div class="text-block" style="margin-left: 10%;">
     
      <!-- <button mat-raised-button   (click)="generateGETInspectionReport()">Preview Report</button>
      <button mat-raised-button >Send Report</button>
      <button mat-raised-button (click) ="openReportContactDialog()" >Report Contacts</button>   -->
      <!-- <mat-form-field class="DBSS" style="margin-left: 1%;">
        <input matInput placeholder="Report Name" [(ngModel)]="GETReportName" name="undercarriageReportName">   
      </mat-form-field>     -->
  </div>
  </div>
  
      <div *ngIf="isLoadingGetTable ==true">
      <mat-card style="margin-top: 10px;">  
        <div style="display: flex;flex-direction: row;">
        <div  style="overflow-x: auto; ">          
        <table  class="table table--full-width table--striped">
          <thead>
            <!-- <tr>
              <th><mat-checkbox ></mat-checkbox></th>
              <th colspan="4">Unit 605 Inspection on 21 Feb 2020 SMU 14213</th>
              <th colspan="4">Unit 605 Inspection on 21 Feb 2020 SMU 14213</th>
              <th colspan="5">% Worn Diff. betw.Inspections  Cost associated with difference </th>
            </tr> -->
            <tr>
             <th></th>
             <th>{{'Component Type' | translate | async}}</th> 
             <th>{{'Component' | translate | async}}</th>
              <!-- <th>Part#</th> -->
             <th>{{'Observation Point' | translate | async}}</th>
              <th>{{inputGetONHireInspectionDate| date:'dd-MMM-yyyy'}}</th>
              <!-- <th style="padding: 16px 0px;">Worn</th> -->
              
            </tr>
          </thead>
          <tbody>
            
            <ng-container *ngFor="let comp of  InspectionObservationComponents_; let i =  index">
                
            <tr>    
              <td style="padding: 13px 24px;"> <mat-checkbox  [checked]="Checkbox_GET" (change)='checkboxChangedGET($event,i);'></mat-checkbox></td>
                <td style="padding: 16px 24px;"> {{comp.ComponentType }}</td>                            
                <td style="padding: 16px 24px;"> {{comp.ComponentName }} </td>                
                <!-- <td style="padding: 16px 24px;">{{comp.PartNumber }}</td>                                  -->
                <td style="padding: 16px 24px;">{{comp.ObservationName}} </td>
                <!-- <td style="padding: 16px 24px;">{{comp.WornPercentage.toFixed(1)}}%  /  {{comp.Reading.toFixed(1)}} mm</td>   -->

                <td class="tdClass" style="padding: 9px 17px;">    
                  <span  class="Eval-U" style="margin-right: 50px; padding: 2px 5px;">
                    <div> {{comp.WornPercentage.toFixed(1)}}%</div>{{comp.Reading.toFixed(1)}} mm 
                </span> 
                </td> 
               
            </tr>
          </ng-container>
        
          </tbody>
        </table>  
        </div>
        
        <div  style="overflow-x: auto; ">          
          <table  class="table table--full-width table--striped" >
            <thead>
              <!-- <tr>
                <th><mat-checkbox ></mat-checkbox></th>
                <th colspan="4">Unit 605 Inspection on 21 Feb 2020 SMU 14213</th>
                <th colspan="4">Unit 605 Inspection on 21 Feb 2020 SMU 14213</th>
                <th colspan="5">% Worn Diff. betw.Inspections  Cost associated with difference </th>
              </tr> -->
              <tr>
                <!-- <td> <mat-checkbox ></mat-checkbox></td> -->
                <th >{{inputGetOFFHireInspectionDate| date:'dd-MMM-yyyy'}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let comp of  InspectionObservationComponents_OFF">              
              <tr >                             
                  <!-- <td style="padding: 17.5px 24px;">{{comp.WornPercentage.toFixed(1)}}%  /  {{comp.Reading.toFixed(1)}} mm </td>    -->
                  
                <td class="tdClass" style="padding: 9px 17px;">    
                  <span  class="Eval-U" style="margin-right: 50px; padding: 2px 5px;">
                    <div> {{comp.WornPercentage.toFixed(1)}}%</div>{{comp.Reading.toFixed(1)}} mm 
                </span> 
                </td>     
              </tr>           
          </ng-container>
            </tbody>
          </table>  
          </div>
          <div  style="overflow-x: auto; ">
            <table class="table table--striped table--full-width">
              <thead>
                <tr>                         
                  <th>{{'Difference' | translate | async}}</th>   
                  <th style="width: 30%;">
                    {{'Cost' | translate | async}}
                  </th>
                  <th>{{'Charged Cost Value' | translate | async
                    }}
                  </th>            
                </tr>
              </thead>   
              <tbody>         
              <ng-container *ngFor=" let row of worndifferenceGET; let i = index">                      
                <tr>           
                  <td style="padding: 19px 24px;"> {{row[0].Worn}}% </td>                  
                  <td style="padding: 15.5px 24px;"> <input type="number" style="border-width: 1px; width: 60%;" (input)="calWornGET(row[0], $event,row,i); getTotalCostGET(i);" ></td>                 
                  <td style="padding: 17px 24px;">${{row[0].Calc>0 ?(row[0].Calc).toFixed(2): 0}}</td>                                                       
                </tr>  
            </ng-container>
            </tbody>  
            </table>
          </div>

          
      </div> 
      <div class="column-container__column" style="margin-top: 1%">
        <div style="flex: 1">
          <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Leave a Comment' | translate | async}}</h4>         
            <mat-form-field style="width: 1000px; " >                 
              <textarea class="sc-textarea" matInput [(ngModel)]="inputGetComment" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>                       
            <mat-form-field  appearance="fill" style="width: 400px;">
              <mat-label>{{'Charged Cost' | translate | async}}</mat-label>
              <mat-icon style="font-size: 15px;" matPrefix>$</mat-icon>
              <input matInput value="cost" [(ngModel)]="TotalCostGET">                    
          </mat-form-field>

          <mat-icon [ngStyle]="{ color: isUCfileUploades ? 'blue' : 'black' }" (click)="AddAttachmentDialogComponentGET()" style="cursor:pointer;">attach_file</mat-icon>                                                                                    
                
          <i (click)="inputValueImage.click()" class="material-icons button__icon"
            style="color:black;cursor: pointer;margin-right: 20px;">{{isGETimageUploads ? "insert_photo":"wallpaper"}}
            <input  #inputValueImage type="file" accept="image/*" style="display:none" (change)="onImageChangedGET($event);">
          </i>                          
        </div>
        <div class="text-block">                   
                    
        </div>                
      </div>          
    </mat-card>
  </div>
 </div>

  <!-- end get implement tab -->


  <!-- digital From tab -->
  <div *ngFor="let container3 of DigitalFormsContainer">
  <div *ngIf="isShowDigitalFormTab==true">
    <div class="panel__content flex flex--align-center">
      <div class="overall-eval-container">
         <div class="margin-bottom-24">
           <mat-label>{{'Digital Forms' | translate | async}}</mat-label>
        <span class="material-icons" style="vertical-align: middle; cursor: pointer;" (click) ="showDigitalFormTable(container3)">fact_check </span>
       </div>
      </div>
    <div class="column-container flex-grow" style="margin-left: 1%;">
     <div class="column-container__column">
      <div class="text-block">
        <mat-form-field appearance="DBSS" style="width: 400px;">
          <mat-label>{{'Pre-Delivery Inspection' | translate | async}}</mat-label>
          <input matInput [matDatepicker]="picker5" type="picker5" [(ngModel)]="preDeliveryInspectionDate" [ngModelOptions]="{standalone: true}">
          <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
          <mat-datepicker #picker5></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="DBSS" style="width: 400px;">
          <mat-label>{{'Post-Delivery Inspection' | translate | async}}</mat-label>
          <input matInput [matDatepicker]="picker6" type="picker6" [(ngModel)]="postDeliveryInspectionDate" [ngModelOptions]="{standalone: true}">
          <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
          <mat-datepicker #picker6></mat-datepicker>
        </mat-form-field>
      </div>                
    </div>   
    </div>

    </div>
                                         
    
      <div *ngIf="container3.isShowDigitalFormTable == true" >
      <mat-card style="margin-top: 10px;">            
        <table>
          <thead>
            <tr>
              <th><mat-checkbox ></mat-checkbox></th>
              <th colspan="4">{{'Unit 605 Inspection on 21 Feb 2020 SMU 14213' | translate | async}}</th>
              <th colspan="4">{{'Unit 605 Inspection on 21 Feb 2020 SMU 14213' | translate | async}}</th>
              <th colspan="5">{{'% Worn Diff. betw.Inspections  Cost associated with difference' | translate | async}} </th>
            </tr>
            <tr>
              <td> <mat-checkbox ></mat-checkbox></td>
              <td>{{'Links' | translate | async}}</td>
              <td>{{'Left' | translate | async}}</td>
              <td>{{'Right' | translate | async}}</td>
              <td></td>
              <td>{{'Links' | translate | async}}</td>
              <td>{{'Left' | translate | async}}</td>
              <td>{{'Right' | translate | async}}</td>
              <td></td>
              <td>{{'Left % Used' | translate | async}}</td>
              <td>{{'Right % Used' | translate | async}}</td>
              <td>{{'Original Costs' | translate | async}}</td>
              <td>{{'Left' | translate | async}}</td>
              <td>{{'Right' | translate | async}}</td>

            </tr>
          </thead>
          <tbody>
            <tr>
              <td> <mat-checkbox ></mat-checkbox></td>
              <td>data One</td>
              <td>data Two</td>
              <td>data Three</td>
              <td>data One</td>
              <td>data Two</td>
              <td>data Three</td>
              <td>data One</td>
              <td>data Two</td>
              <td>data Three</td>
              <td>data One</td>
              <td>data Two</td>
              <td>data Three</td>
              <td>data Three</td>
            </tr>
          </tbody>
        </table>  
        
        <div class="column-container__column" style="margin-top: 1%">
          <div style="flex: 1">
            <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Leave a Comment' | translate | async}}</h4>         
              <mat-form-field style="width: 1000px; " >                 
                <textarea class="sc-textarea" matInput [(ngModel)]="Comment" [ngModelOptions]="{standalone: true}"></textarea>
              </mat-form-field>                       
              <mat-form-field  appearance="fill" style="width: 400px;">
                <mat-label>{{'Total Cost' | translate | async}}</mat-label>
                <input matInput value="cost">                    
            </mat-form-field>
          </div>

          <div class="text-block">                   
            
            
          </div>                
        </div>             
    </mat-card>
  </div>
</div>
</div>
  
  <!-- end Digital Form Tab -->
            <!-- <mat-card style="margin-top: 20px;">
              <div class="panel__content flex flex--align-center">
                <div class="overall-eval-container">
                   <div class="margin-bottom-24">
                  <mat-label>Add Additional Files</mat-label>                
                 </div>
                </div>
                <div class="column-container flex-grow" style="margin-left: 1%;"> 
                  <div class="column-container__column">
                    <div class="text-block">                   
                          <mat-icon style="cursor:pointer;"> attach_file</mat-icon>                                                                          
                    </div>
                    <div  class="example-full-width" style="width: 500px;display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;">
                      
                      <div>
                        <label>             
                          <input type="file" #fileUploader  name="upload" accept="application/pdf,application/vnd.ms-excel" (change)="onFileChanged($event);">       
                        </label>
                      </div>
                    </div>                
                  </div>               
               </div>       
              </div>
              
            </mat-card> -->

           
              
          
          <!-- <div>
            <button mat-raised-button (click)="goBackStep()">Back</button>
            <button  mat-raised-button color="warn" (click)="goToStep(2)" >Next</button>                 
          </div> -->
        </div>
      </mat-step>
      
      <!-- <mat-step >
        <ng-template matStepLabel>Prepare Report, Add Contacts and Send Report</ng-template>
        <div class="margin-bottom-24">
          
        </div>
     
     
        <div class="step-container">
          <div>
            <button mat-raised-button  (click)="goBackStep()">Back</button>
           </div>
        </div>
      </mat-step> -->
    </mat-horizontal-stepper>
  </div>
    </div>
  
